<template>
    <div class="set">
        <div class="seturl">
            <div class="text">BASEURL</div>
            <el-input type="text" v-model="value1"></el-input>
            <el-button type="primary" @click="clickUrl">确定</el-button>
        </div>
        <div class="demo">
            示例：http://192.168.1.32/index.php
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            value1: ''
        }
    },
    mounted() {
        this.value1 = window.localStorage.getItem('baseurl')
    },
    methods: {
        clickUrl() {
            if (!this.value1) return
            window.localStorage.setItem('baseurl', this.value1)
            this.$message({message: '切换请求域名完成,请刷新页面', type: 'success'})
            this.$router.push('/')
            this.$nextTick(() => {
                location.reload()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.set {
    width: 100%;
    height: 100%;
}
.seturl {
    width: 450px;
    padding-top: 300px;
    margin: auto;
    display: flex;
    align-items: center;
    .text {
        font-size: 16px;
        color: #000;
        margin-right: 12px;
    }
    .el-button  {
        margin-left: 16px;
    }
}
.demo {
    margin: 16px;
    font-size: 16px;
    text-align: center;
    color: #000;
    width: 98%;
}
</style>